<script lang="ts" setup>
import type { EditorialProductHero } from '@integration-layer/ampliance/schemas/editorial-product-hero-schema.localized'
import type { EditorialProductHeroProps } from '@design-system/components/Editorial/EditorialProductHero.props'
import type { UIMediaProps } from '@design-system/components/UI/UIMedia.props'
import type { ProductTileProps } from '@design-system/components/UI/UIProductTile.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialProductHero
}>()

const data = await useComponentResponse<EditorialProductHero>(props)
const { getProducts } = useShopTheLook()

const { data: products } = await useAsyncData(
  () => getProducts(data?.value?.products as string[]),
  {
    watch: [() => data?.value?.products],
    default: () => [],
  }
)
</script>

<template>
  <EditorialProductHero
    v-if="data"
    :products="products"
    :inverted="data?.inverted"
    :media="data?.media as unknown as UIMediaProps"
  />
</template>
